var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34363 8.98486L10.9843 2.34424C11.4432 1.88525 12.1854 1.88525 12.6395 2.34424L13.743 3.44775C14.202 3.90674 14.202 4.64893 13.743 5.10303L9.0409 9.81494L13.7479 14.522C14.2069 14.981 14.2069 15.7231 13.7479 16.1772L12.6444 17.2856C12.1854 17.7446 11.4432 17.7446 10.9891 17.2856L4.34851 10.645C3.88465 10.186 3.88465 9.44385 4.34363 8.98486Z",
    fill: "#0029FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.0d30464236741d675ec34ee7dbe4a2b8.svg";
export { ForwardRef as ReactComponent };